import EnumConfig from './EnumConfig.jsx';

const EXTRA = [
  { key: 'min_items', label: 'Min items', kind: 'integer' },
  { key: 'max_items', label: 'Max items', kind: 'integer' },
];

export default function MultiCheckboxConfig({ field, onConfigChange }) {
  return <EnumConfig field={field} onConfigChange={onConfigChange} extraSchema={EXTRA} />;
}
